import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import { Observable } from 'rxjs';

// Uno por carga de la app: los cambios de idioma dentro de la sesión reutilizan la caché.
const I18N_CACHE_BUSTER = Date.now();

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private _httpClient = inject(HttpClient);

    /**
     * Get translation
     *
     * @param lang
     */
    getTranslation(lang: string): Observable<Translation> {
        // Cache-buster: sin él el navegador sirve el JSON viejo tras un deploy y
        // las claves nuevas se muestran sin traducir.
        return this._httpClient.get<Translation>(`./i18n/${lang}.json?v=${I18N_CACHE_BUSTER}`);
    }
}
